import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Carousel, Layout, message, Modal, notification } from 'antd';
import { Icon } from '@ant-design/compatible';
import moment from 'moment';

import SideBar from '../sidebar/SideBar';
import Header from '../header/Header';
import UsuarioFormulario from '../../../pages/usuario/formulario/UsuarioFormulario';
import { logOut, updateProfile } from '../../../redux/account/account.actions';
import {
  addNewNotification,
  readNotification,
} from '../../../redux/notification/notification.actions';
import { find as findUser, getMenus } from '../../services/http/UsuarioService';
import { QuadrosAvisoService } from '../../services/http/QuadrosAvisoService';
import { getOrdersByStatus } from '../../services/http/DashboardService';
import {
  markOrderAsRead,
  watchResaleNewOrders,
} from '../../services/http/PedidoService';
import { organizacaoService } from '../../services/http/OrganizacaoService';
import {
  getUser,
  isOrganization,
  isResale,
  isUpgasEmployee,
  isUserResale,
} from '../../services/UserService';
import OrderSoundPlayer from '../order-sound-player/OrderSoundPlayer';
import './Layout.scss';
import { termosECondicoes } from '../../services/TermosECondicoesService';
import DetalhePedido from '../../../pages/pedidos/detalhe/DetalhePedido';
import { ResaleStatusContext } from '../../contexts/ResaleStatusContext';
import { DashboardDateContext } from '../../contexts/DashboardDateContext';
import { queryClient } from '../../../App';
import { DashboardOperacaoStatusEnum } from '../../Enum/DashboardOperacaoStatusEnum';
import soundService from '../order-sound-player/SoundService';

export const SUSPENDED_ORGANIZATION_NOTIFICATION_KEY =
  'SUSPENDED_ORGANIZATION_NOTIFICATION';
export const CLOSED_RESALES_NOTIFICATION_KEY = 'CLOSED_RESALES_NOTIFICATION';
export const REFUSED_TERMS_AND_CONDITIONS_NOTIFICATION_KEY =
  'REFUSED_TERMS_AND_CONDITIONS_NOTIFICATION';
export const PENDENT_BILLET_NOTIFICATION_KEY =
  'REFUSED_TERMS_AND_CONDITIONS_NOTIFICATION';
const DELAYED_ORDER_ALERT_THRESHOLD_MINUTES = 30;
const DELAYED_ORDER_ALERT_INTERVAL_MS = 60000;
const DASHBOARD_OPERATION_PATHS = ['/', '/dashboard/operacao'];

const isClosedResale = (resale = {}) => resale.aberta === false;

const normalizeResalesResponse = (response) =>
  Array.isArray(response) ? response : response?.result || [];

const isDashboardOperationPath = (pathname) =>
  DASHBOARD_OPERATION_PATHS.includes(pathname);

class UpgasLayout extends Component {
  constructor(props) {
    super(props);

    const soundMutedOnStorage = localStorage.getItem('notification-bell-muted');

    this.state = {
      collapsed: false,
      userFormIsOpen: false,
      resaleRatioFormIsOpen: false,
      loadingMenus: isUpgasEmployee(),
      employeeMenus: [],
      user: {},
      configuration: { ratio: 0, contribuitionPercent: 0 },
      isSoundMuted: soundMutedOnStorage
        ? JSON.parse(soundMutedOnStorage)
        : false,
      pedidoSelecionado: false,
      orderId: '',
      resaleName: null,
      isAnyResaleOpen: false,
      closedResalesCount: 0,
      dashboardDate: moment(),
    };

    this.unsubscribeNewOrders = null;
    this.delayedOrdersInterval = null;
    this.alertedDelayedOrderIds = new Set();
  }

  componentDidMount() {
    if (isUpgasEmployee()) this.getEmployeeMenus();

    if (isOrganization()) {
      const { account } = this.props;

      this.getOrganizationData();
      this.getOrganizationResalesData();
      this.getOrganizationNotices();
      this.watchNewOrders(account.id, account.role);
      this.startDelayedOrdersMonitor();
    }

    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps) {
    const previousPathname = prevProps.location?.pathname;
    const currentPathname = this.props.location?.pathname;

    if (
      isOrganization() &&
      previousPathname !== currentPathname &&
      isDashboardOperationPath(currentPathname)
    ) {
      this.getOrganizationResalesData();
    }
  }

  componentWillUnmount() {
    if (this.unsubscribeNewOrders) {
      this.unsubscribeNewOrders();
    }

    if (this.delayedOrdersInterval) {
      clearInterval(this.delayedOrdersInterval);
    }

    window.removeEventListener('resize', this.handleResize);

    const keysToClose = [
      CLOSED_RESALES_NOTIFICATION_KEY,
      REFUSED_TERMS_AND_CONDITIONS_NOTIFICATION_KEY,
      SUSPENDED_ORGANIZATION_NOTIFICATION_KEY,
      PENDENT_BILLET_NOTIFICATION_KEY,
    ].filter(Boolean);

    if (notification && typeof notification.close === 'function') {
      keysToClose.forEach((key) => notification.close(key));
    }
  }

  getEmployeeMenus = () => {
    getMenus(getUser().userId)
      .then((res) => this.setState({ employeeMenus: res }))
      .catch(() => message.error('Falha ao obter informação de menus'))
      .finally(() => this.setState({ loadingMenus: false }));
  };

  getOrganizationData = () => {
    const { id } = getUser();

    organizacaoService
      .getById(id)
      .then((organization) => {
        if (organization.suspensa) {
          this.openFixedNotifications({
            key: SUSPENDED_ORGANIZATION_NOTIFICATION_KEY,
            message: 'A sua organização está suspensa',
            description:
              'A sua organização está suspensa e NÃO está visível para os clientes. Por favor entre em contato com o Upgas',
          });
        }

        if (organization.termosECondicoes === termosECondicoes.Recusou.Enum) {
          this.openFixedNotifications({
            key: REFUSED_TERMS_AND_CONDITIONS_NOTIFICATION_KEY,
            message:
              'Você ainda não aceitou os Termos & Condições da plataforma Upgas',
            description:
              'Para seguir recebendo pedidos pelo App, por favor leia os Termos com atenção e clique em aceitar',
          });
        }

        if (organization.possuiBoletosPendentes) {
          const today = new Date();
          const lastSeenDay =
            organizacaoService.getBilletNotificationLastSeenDay();
          const seenToday = moment(lastSeenDay).isSame(moment(today), 'day');

          if (!seenToday) {
            this.openFixedNotifications({
              key: PENDENT_BILLET_NOTIFICATION_KEY,
              message: 'Chegou um boleto para você!',
              description: 'Clique aqui, vá em "documentos" para visualiza-lo!',
              onClick: () => this.props.history.push('/financas/balancos'),
            });

            organizacaoService.updateBilletNotificationLastSeenDay(today);
          }
        }
      })
      .catch((err) => message.error(err));
  };

  getOrganizationResalesData = () => {
    organizacaoService
      .getResales()
      .then((response) => {
        const resales = normalizeResalesResponse(response);
        const closedResales = resales.filter(isClosedResale);
        const closedResalesLength = closedResales.length;

        this.setState({ closedResalesCount: closedResalesLength });

        if (closedResalesLength > 0) {
          const closedResaleNames = closedResales
            .slice(0, 5)
            .map(({ nomeFantasia }) => nomeFantasia)
            .join(' - ');

          this.openFixedNotifications({
            key: CLOSED_RESALES_NOTIFICATION_KEY,
            message: 'Revendas fechadas',
            description: `Você está com ${closedResalesLength} ${
              closedResalesLength > 1 ? 'revendas fechadas' : 'revenda fechada'
            }: ${closedResaleNames}${
              closedResalesLength > 5
                ? `\n...e mais ${closedResalesLength - 5} revendas`
                : ''
            }`,
          });
        }
      })
      .catch((err) => message.error(err));
  };

  getOrganizationNotices = async () => {
    try {
      const avisos = await QuadrosAvisoService().getResaleAvisos();
      const notReadAvisos = avisos.filter(
        ({ id }) => !QuadrosAvisoService().getReadAvisos().includes(id),
      );

      if (notReadAvisos.length === 0) return;

      Modal.info({
        title: 'Avisos',
        width: 1000,
        bodyStyle: { height: 320, overflowY: 'scroll' },
        onOk: () =>
          QuadrosAvisoService().setAvisosAsRead(
            notReadAvisos.map(({ id }) => id),
          ),
        content: (
          <Carousel autoplay autoplaySpeed={3500}>
            {notReadAvisos.map(({ titulo, aviso, imagem }, index) => (
              <div key={index}>
                <h1>{titulo}</h1>
                <p style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
                  {aviso}
                </p>
                {imagem && imagem !== '' && (
                  <img
                    className='aviso-imagem'
                    src={imagem}
                    alt='imagem do aviso'
                  />
                )}
              </div>
            ))}
          </Carousel>
        ),
      });
    } catch (e) {
      message.error('Falha ao obter avisos');
    }
  };

  startDelayedOrdersMonitor = () => {
    this.checkDelayedOrders();
    this.delayedOrdersInterval = setInterval(
      this.checkDelayedOrders,
      DELAYED_ORDER_ALERT_INTERVAL_MS,
    );
  };

  checkDelayedOrders = () => {
    getOrdersByStatus(moment())
      .then(({ emAndamento = [] }) => {
        const newDelayedOrders = emAndamento
          .filter(this.isOrderDelayed)
          .filter((order) => {
            const orderId = order.idPedido;
            if (!orderId || this.alertedDelayedOrderIds.has(orderId)) {
              return false;
            }

            this.alertedDelayedOrderIds.add(orderId);
            return true;
          });

        if (newDelayedOrders.length === 0) return;

        if (!this.state.isSoundMuted) {
          newDelayedOrders.forEach(() => soundService.playSound());
        }

        if (newDelayedOrders.length === 1) {
          this.openDelayedOrderModal(newDelayedOrders[0]);
          return;
        }

        this.openDelayedOrdersSummaryModal(newDelayedOrders.length);
      })
      .catch((error) => console.error(error));
  };

  isOrderDelayed = (order) => {
    if (!order.limiteEntrega) return false;

    const deliveryLimit = moment(order.limiteEntrega);
    if (!deliveryLimit.isValid()) return false;

    return (
      moment().diff(deliveryLimit, 'minutes') >=
      DELAYED_ORDER_ALERT_THRESHOLD_MINUTES
    );
  };

  getDelayedOrderDescription = (order) => {
    const identifier = order.protocolo
      ? `Pedido ${order.protocolo}`
      : 'Pedido em andamento';
    const customer = order.nomeCliente ? ` - ${order.nomeCliente}` : '';
    const resale = order.nomeRevenda ? ` (${order.nomeRevenda})` : '';

    return `${identifier}${customer}${resale} está atrasado há mais de 30 minutos.`;
  };

  openDelayedOrderModal = (order) => {
    Modal.info({
      title: 'Pedido atrasado',
      okText: 'Ir para o pedido',
      maskClosable: true,
      content: (
        <section>
          <p>{this.getDelayedOrderDescription(order)}</p>
        </section>
      ),
      onOk: () => this.openDelayedOrderDetails(order.idPedido),
    });
  };

  openDelayedOrdersSummaryModal = (ordersQuantity) => {
    const date = moment().format('YYYY-MM-DD');

    Modal.info({
      title: 'Pedidos atrasados',
      okText: 'Ir para pedidos',
      maskClosable: true,
      content: (
        <section>
          <p>{`${ordersQuantity} pedidos estão atrasados há mais de 30 minutos.`}</p>
        </section>
      ),
      onOk: () =>
        this.props.history.push(
          `/operacao/pedidos/${DashboardOperacaoStatusEnum.Atrasados}/${date}`,
        ),
    });
  };

  openDelayedOrderDetails = (orderId) => {
    this.setState({
      pedidoSelecionado: true,
      orderId,
    });
  };

  watchNewOrders = (id, role) => {
    this.unsubscribeNewOrders = watchResaleNewOrders(id, role, (orders) => {
      const { notifications } = this.props;
      const notReadOrders = orders.filter(({ Read }) => !Read);
      const notReadOrdersNotifications = notReadOrders.map((order) => ({
        id: order.OrderId,
        read: order.read || false,
        title: 'Existe um novo pedido',
        icon: 'shopping-cart',
        date: moment(),
        action: (data) => {
          markOrderAsRead(data.id).then(() =>
            this.props.history.push(`/dashboard/operacao`, {
              id: order.OrderId,
            }),
          );
        },
        payload: order,
      }));

      console.log(notReadOrders);
      if (!notReadOrders || notReadOrders.length == 0) {
        this.setState({ isSoundEnabled: false });
        Modal.destroyAll();
        return;
      }

      // TODO: ver se esse snapshot sempre traz tudo ou depois só traz os novos! (dá pra tentar simplificar codigo)
      const newNotifications = notReadOrdersNotifications.filter(
        (n) => !notifications.find((x) => x.id === n.id),
      );

      if (newNotifications.length > 0) this.setState({ isSoundEnabled: true });

      newNotifications.forEach((notification) => {
        this.props.addNewNotification(notification);

        this.openNotification(notification);
        this.openModal(notification);
      });
    });
  };

  openNotification = (data) => {
    notification.open({
      key: data.id,
      onClick: () => this.onNotificationClick(data),
      placement: 'bottomRight',
      message: 'Existe um novo pedido',
      description: 'Um novo pedido acaba de ser solicitado.',
      icon: <Icon type={data.icon} style={{ color: '#108ee9' }} />,
    });
  };

  openFixedNotifications = ({ description, message, key, onClick }) => {
    notification.open({
      className: 'fixed-notification',
      key,
      message,
      description,
      duration: null,
      placement: 'bottomRight',
      onClick,
    });
  };

  onNotificationClick = (data) => {
    data.action(data.payload);
    notification.close(data.id);
    this.props.readNotification(data);
  };

  openModal = (data) => {
    Modal.info({
      title: 'Existe um novo pedido',
      okText: 'Ir para o pedido',
      maskClosable: true,
      content: (
        <section>
          <p>Um novo pedido acaba de ser solicitado.</p>
        </section>
      ),
      onOk: () => {
        //data.action(data.payload)
        this.props.readNotification(data);

        this.setState({
          pedidoSelecionado: true,
          orderId: data.id,
        });
      },
    });
  };

  toggleSoundMute = () => {
    localStorage.setItem(
      'notification-bell-muted',
      (!this.state.isSoundMuted).toString(),
    );
    this.setState({ isSoundMuted: !this.state.isSoundMuted });
  };

  handleResize = () => {
    const isMobile = window.innerWidth <= 768;
    if (isMobile && !this.state.collapsed) {
      this.setState({ collapsed: true });
    }
  };

  toggle = () => this.setState(({ collapsed }) => ({ collapsed: !collapsed }));

  setResaleName = (name) => this.setState({ resaleName: name });

  setIsAnyResaleOpen = (val) => this.setState({ isAnyResaleOpen: val });

  closeAllResales = async () => {
    try {
      await organizacaoService.closeResales();
      this.setState({ isAnyResaleOpen: false });
      queryClient.invalidateQueries('resale');
    } catch (error) {
      console.error(error);
    }
  };

  setDashboardDate = (date) => this.setState({ dashboardDate: date });

  openProfile = () => {
    if (isResale() || isUserResale()) this.openResaleProfile();
  };

  openResaleProfile = () => {
    const { id } = getUser();
    this.props.history.push(`/revendas/${id}`);
  };

  openUserProfile = () => {
    const { userId } = getUser();
    findUser(userId)
      .then((user) =>
        this.setState((prevState) => ({
          userFormIsOpen: !prevState.userFormIsOpen,
          user,
        })),
      )
      .catch((error) => message.error(error));
  };

  openParameters = () => {
    const { id } = getUser();
    this.props.history.push(`/parametros-operacao/${id}`);
  };

  closeUserForm = (callback) => {
    this.setState({ userFormIsOpen: false, user: {} }, () => {
      callback.reset();
      if (callback.user) {
        this.props.dispatch(updateProfile(callback.user));
      }
    });
  };

  closeResaleRatioForm = (callback) => {
    this.setState({ resaleRatioFormIsOpen: false, user: {} }, () => {
      callback();
    });
  };

  logOut = () => {
    this.props.logOut();
    this.props.history.push(`/login`);
  };

  handleOnClose = async () => {
    await this.setState({ pedidoSelecionado: false });
  };

  render() {
    const {
      collapsed,
      userFormIsOpen,
      user,
      isSoundMuted,
      loadingMenus,
      employeeMenus,
      isSoundEnabled,
    } = this.state;

    return (
      <DashboardDateContext.Provider
        value={{
          date: this.state.dashboardDate,
          setDate: this.setDashboardDate,
        }}>
        <ResaleStatusContext.Provider
          value={{
            resaleName: this.state.resaleName,
            setResaleName: this.setResaleName,
            isAnyResaleOpen: this.state.isAnyResaleOpen,
            setIsAnyResaleOpen: this.setIsAnyResaleOpen,
            closeAllResales: this.closeAllResales,
            closedResalesCount: this.state.closedResalesCount,
          }}>
          <Layout hasSider>
            {!collapsed && (
              <div className='sidebar-overlay' onClick={this.toggle} />
            )}
            <SideBar
              employeeMenus={employeeMenus}
              loading={loadingMenus}
              logOut={() => this.logOut()}
              openUserProfile={this.openUserProfile}
              openParameters={this.openParameters}
              openProfile={this.openProfile}
              onToggle={this.toggle}
              isCollapsed={collapsed}
            />
            <Layout>
              <Header
                openParameters={this.openParameters}
                openProfile={this.openProfile}
                onToggle={this.toggle}
                onNotificationClick={this.onNotificationClick}
                toggleSoundMute={this.toggleSoundMute}
                muted={isSoundMuted}
                isCollapsed={collapsed}
              />
              {this.props.children}
              <UsuarioFormulario
                user={user}
                onClose={this.closeUserForm}
                isOpen={userFormIsOpen}
              />
              {this.state.pedidoSelecionado && (
                <DetalhePedido
                  onClose={this.handleOnClose}
                  orderId={this.state.orderId}
                  isOpen={this.state.pedidoSelecionado}
                />
              )}
              <OrderSoundPlayer
                isSoundEnabled={!isSoundMuted && isSoundEnabled}
              />
            </Layout>
          </Layout>
        </ResaleStatusContext.Provider>
      </DashboardDateContext.Provider>
    );
  }
}

const mapActionToProps = (dispatch) =>
  bindActionCreators(
    { dispatch, updateProfile, logOut, addNewNotification, readNotification },
    dispatch,
  );

const mapStateToProps = ({ account, notifications }) => ({
  account,
  notifications,
});

export default withRouter(
  connect(mapStateToProps, mapActionToProps)(UpgasLayout),
);
